<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Disclaimer</h3>
        <p>Stumpthespread.com is not responsible for any decisions made, financial or otherwise, based on information or links provided by Stumpthespread.com. The information we provide is for informational and educational purposes only. Stumpthespread.com does not guarantee any of the suggestions made. Past results do not guarantee future success.</p>
        <p>Stumpthespread.com and its tipsters, contributors, sponsors, advertisers, email correspondence and any information appearing on this site are not meant in any way to be a source of professional advice or recommendations to in any way gamble, place bets and/or wager and no reliance is to be placed on the same. We do not undertake any responsibility and/or liability for any losses and/or damages sustained by any person or persons using services on our site and we shall not be responsible and/or liable for any losses or damages due to any information or otherwise contained on this web site or through links, sponsors and email correspondence, whether due to inaccuracy, error, omission or bad judgment or any reason whatsoever.</p>
        <p>Stumpthespread.com is not responsible in any way regarding picks and predictions posted through email. We advise all viewers to use discretion when viewing our picks. Please bet within your means. If you encounter gambling problems of any kind, please contact the gambling help authorities in your area. Please visit, Gamblers Anonymous.</p>
        <p>Stumpthespread.com notes that odds and betting lines tend to fluctuate often without notice. We will not be liable for any incorrect odds and lines.</p>
        <p>Stumpthespread.com does not provide gaming or gambling capabilities on its site. It is a sports information site, although odds and betting lines are part of that information. It is very important to check the laws and regulation in your own country regarding gambling and sports betting, as it might differ from country to country.</p>
        <p>Stumpthespread.com is not responsible for any fees or inconveniences which result from either our email or text messaging systems. We encourage all viewers to only choose the text messaging option if their phone plan supports it. StumptheSpread will not reimburse any one for accrued text messaging or phone bills. Nor will we be held responsible for any issues from our text messaging or email system.</p>
        <p>All sales made at StumptheSpread are final. No reimbursements or refunds will be given for any reason. </p>
        <p>Any further questions may be directed to policy@stumpthespread.com</p>
      </div>
      <!-- main-colum END here -->
      <sidebar :testimonial="testimonial"></sidebar>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/sidebar'
export default {
  components: {
    'sidebar': Sidebar
  },
  data () {
    return {

    }
  },
  metaInfo: {
    title: 'Disclaimer'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Disclaimer.vue?0715933f